import React, { useState } from "react";
import { ReportAPI } from "../../api/apiClient";
import { useUI } from "../../context/UIContext";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

interface Row {
  drsDate: string;
  note: string;
  remarks: string;
}

export default function WeatherKeywordReport() {

  const { selectedProjectId, selectedProjectName } = useUI();

  const [fromDate,setFromDate] = useState("");
  const [toDate,setToDate] = useState("");
  const [keyword,setKeyword] = useState("");

  const [rows,setRows] = useState<Row[]>([]);
  const [view,setView] = useState<"filter" | "report">("filter");


/* =============================
   DATE FORMAT
============================= */

const formatDate = (dateStr:string) => {

  if(!dateStr) return "";

  const date = new Date(dateStr);

  if(isNaN(date.getTime())) return "";

  const day = date.getDate().toString().padStart(2,"0");
  const month = date.toLocaleString("en-GB",{month:"short"});
  const year = date.getFullYear().toString().slice(-2);

  return `${day}-${month}-${year}`;
};


/* =============================
   LOAD REPORT
============================= */

const loadReport = async () => {

  if(!selectedProjectId || !fromDate || !toDate) return;

  const data = await ReportAPI.getWeatherKeywordReport({
    projectId:selectedProjectId,
    startDate:fromDate,
    endDate:toDate,
    keyword:keyword
  });

  setRows(data);

  setView("report");
};


/* =============================
   EXPORT PDF
============================= */

const exportPDF = () => {

  const pdf = new jsPDF("p","mm","a4");

  const pageWidth = pdf.internal.pageSize.getWidth();

  pdf.setFontSize(14);

  pdf.text("Keyword Report",14,15);

  pdf.setFontSize(10);

  pdf.text(
    `${selectedProjectName}: Weather Statement from ${formatDate(fromDate)} to ${formatDate(toDate)}`,
    14,
    22
  );

  const tableRows:any[] = [];

  rows.forEach((r)=>{

    tableRows.push([
      formatDate(r.drsDate),
      r.note
    ]);

  });

  autoTable(pdf,{
    startY:28,
    head:[["Date","Weather"]],
    body:tableRows,
    theme:"grid",
    styles:{
      fontSize:10
    },
    headStyles:{
      fillColor:[55,65,81]
    }
  });

  const pageCount = pdf.getNumberOfPages();

  for(let i=1;i<=pageCount;i++){

    pdf.setPage(i);

    pdf.setFontSize(9);

    pdf.text(
      `Page ${i} of ${pageCount}`,
      pageWidth-35,
      290
    );

  }

  pdf.save("WeatherKeywordReport.pdf");

};



/* =============================
   SCREEN 1 : FILTER SCREEN
============================= */

if(view === "filter"){

return(

<div className="p-6 space-y-6 max-w-md">

<h2 className="text-xl font-semibold">
Weather Keyword Report
</h2>

<div className="space-y-1">

<label className="text-sm font-medium">
From Date
</label>

<input
type="date"
value={fromDate}
onChange={(e)=>setFromDate(e.target.value)}
className="border p-2 rounded w-full"
/>

</div>


<div className="space-y-1">

<label className="text-sm font-medium">
To Date
</label>

<input
type="date"
value={toDate}
onChange={(e)=>setToDate(e.target.value)}
className="border p-2 rounded w-full"
/>

</div>


<div className="space-y-1">

<label className="text-sm font-medium">
Keyword
</label>

<input
type="text"
value={keyword}
onChange={(e)=>setKeyword(e.target.value)}
className="border p-2 rounded w-full"
/>

</div>


<button
disabled={!fromDate || !toDate}
onClick={loadReport}
className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:bg-gray-400"
>
Run Report
</button>

</div>

);

}



/* =============================
   SCREEN 2 : REPORT SCREEN
============================= */

return(

<div className="p-6 space-y-6">

{/* Export Button */}

<div className="flex justify-end">

<button
onClick={exportPDF}
className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
>
Export PDF
</button>

</div>


<div className="max-w-3xl border shadow-sm">

<div className="bg-gray-700 text-white font-semibold px-4 py-2">
Keyword Report
</div>


<div className="bg-gray-300 text-sm px-4 py-2 font-semibold">

{selectedProjectName}: Weather Statement from {formatDate(fromDate)} to {formatDate(toDate)}

</div>


<div className="text-sm">

{rows.length > 0 && rows.map((r,index)=>(

<div
key={index}
className="grid grid-cols-2 px-4 py-2 border-b"
>

<div>{formatDate(r.drsDate)}</div>

<div>{r.note}</div>

</div>

))}


{rows.length === 0 && (

<div className="px-4 py-4 text-gray-500">
No data for the selected date range
</div>

)}

</div>

</div>


<div>

<button
onClick={()=>setView("filter")}
className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
>
Back
</button>

</div>

</div>

);

}